export default {

    dividerAlign: 'center',
    dividerAlignTablet: null,
    dividerAlignPhone: null,

    dividerWidth: 500,
    dividerWidthTablet: null,
    dividerWidthPhone: null,

    dividerColor: '#000',

    dividerMarginTop: 20,
    dividerMarginBottom: 20,
    dividerMarginTopTablet: null,
    dividerMarginBottomTablet: null,
    dividerMarginTopPhone: null,
    dividerMarginBottomPhone: null,

    dividerHeight: 1,

    dividerType: 'simpleDivider',
    
    dividerTypeObj: {
        simpleDivider : true,
        iconCenterDivider: false,
        iconLeftDivider: false,
        iconRightDivider: false
    },

    iconClass: 'fab fa-weebly',
    iconColor: '#000',
    
    iconSize: 17,
    iconSizeTablet: null,
    iconSizePhone: null
}


// WEBPACK FOOTER //
// ./src/store/elementSettings/horizontaldividersettings.js